import { Dimensions } from 'react-native'

export const isSmall = Dimensions.get('window').width <= 320
